import { render, staticRenderFns } from "./RightSatelliteSublayer.vue?vue&type=template&id=40b1b6a6"
import script from "./RightSatelliteSublayer.vue?vue&type=script&lang=js"
export * from "./RightSatelliteSublayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports